import { render, staticRenderFns } from "./PFormInputFile.vue?vue&type=template&id=1070f3f1&scoped=true"
import script from "./PFormInputFile.vue?vue&type=script&lang=ts"
export * from "./PFormInputFile.vue?vue&type=script&lang=ts"
import style0 from "./PFormInputFile.vue?vue&type=style&index=0&id=1070f3f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1070f3f1",
  null
  
)

export default component.exports